<template>
  <div class="packingList_module">
    <div class="packingList_title">
      <span>装箱单信息</span>
      <el-button type="primary"
                 @click="addBox">添加箱</el-button>
    </div>
    <div class="packingList_module_view">
      <div v-if="xzinfo.xzType&&xzinfo.xzType.length>0">
        <el-tag size="small"
                type="info"
                v-if="xzinfo.xzType.indexOf('1')!=-1">
          最长边限制：{{xzinfo.bcAstrict.one}}CM，次边长限制：{{xzinfo.bcAstrict.two}}CM，最短边限制：{{xzinfo.bcAstrict.three}}CM。
        </el-tag>
        <el-tag size="small"
                type="info"
                v-if="xzinfo.xzType.indexOf('2')!=-1">
          周长限制：{{xzinfo.zcAstrict}}CM。
        </el-tag>
        <el-tag size="small"
                type="info"
                v-if="xzinfo.xzType.indexOf('3')!=-1">
          单箱重量限制：{{xzinfo.zlAstrict}}KG。
        </el-tag>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="(item,index) in tableData"
                          :key="item.no"
                          :name="item.no">
          <div slot="title"
               class="zxdinfo_title">
            <div>{{'第'+item.no+'箱'}} </div>
            <div class="zxdinfo_view"
                 @click.stop="">
              <div class="zxdinfo_view_item">
                <div class="item_title">长：</div>
                <el-input-number v-model="item.chang"
                                 :min="0"
                                 :precision='2'
                                 size="mini"
                                 @change='computedAstrict(index)'
                                 :max="100000">
                </el-input-number>
                <div class="item_unit">CM</div>
              </div>
              <div class="zxdinfo_view_item">
                <div class="item_title">宽：</div>
                <el-input-number v-model="item.kuan"
                                 size="mini"
                                 @change='computedAstrict(index)'
                                 :precision='2'
                                 :min="0"
                                 :max="100000"></el-input-number>
                <div class="item_unit">CM</div>
              </div>
              <div class="zxdinfo_view_item">
                <div class="item_title">高：</div>
                <el-input-number v-model="item.gao"
                                 @change='computedAstrict(index)'
                                 :precision='2'
                                 size="mini"
                                 :min="0"
                                 :max="100000"></el-input-number>
                <div class="item_unit">CM</div>
              </div>
              <div class="zxdinfo_view_item">
                <div class="item_title">重：</div>
                <el-input-number v-model="item.weight"
                                 @change='computedAstrict(index)'
                                 :precision='2'
                                 size="mini"
                                 :min="0"
                                 :max="100000"></el-input-number>
                <div class="item_unit">KG</div>
              </div>
            </div>
          </div>
          <el-table :data="item.wpinfo"
                    border
                    class="expand"
                    style="width: 100%">

            <el-table-column prop="no"
                             label="中文品名">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name"
                          size="mini"
                          placeholder="填写中文名"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="no"
                             label="英文品名">
              <template slot-scope="scope">
                <el-input v-model="scope.row.enname"
                          size="mini"
                          placeholder="英文名"></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="no"
                             label="物品数量">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.num"
                                 :min="1"
                                 size="mini"
                                 :precision='0'
                                 :max="10000"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column prop="no"
                             label="产品单价（元）">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.unitprice"
                                 :min="1"
                                 size="mini"
                                 :precision='2'
                                 :max="1000000"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column prop="no"
                             label="产品总值（元）">
              <template slot-scope="scope">
                <span>{{(scope.row.unitprice*scope.row.num)||'待填写' }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="no"
                             label="操作">
              <template slot-scope="scope">
                <el-link type="danger"
                         v-if="tableData[index].wpinfo.length>1"
                         @click="removeGoods(index,scope.$index)">删除物品</el-link>
              </template>

            </el-table-column>
          </el-table>

          <div class="addGoods">
            <el-button type="success"
                       size="small"
                       @click="addGoods(index)">添加物品</el-button>
            <el-button size="small"
                       @click="copyBox(tableData[index])">复制箱</el-button>
            <el-button type="danger"
                       size="small"
                       v-if="tableData.length>1"
                       @click="removeBox(index)">整箱删除</el-button>
          </div>

        </el-collapse-item>

      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeNames: [1],
    }
  },
  props: {
    // 限制条件
    xzinfo: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    // 表格数据
    tableData: {
      type: Array,
      required: true,
      default: [{
        no: 1,
        wpinfo: [{
          name: ''
        }]
      }]
    }
  },
  methods: {
    //   ---------复制箱----------
    copyBox (row) {
      const res = JSON.parse(JSON.stringify(row))
      this.tableData.push(res)
    },
    //   ---------计算单箱的长宽高重量是否超过限制----------
    computedAstrict (index) {
      console.log(this.tableData[index]);
      function empty (than) {
        than.$nextTick(() => {
          than.tableData[index].chang = 1
          than.tableData[index].kuan = 1
          than.tableData[index].gao = 1
        })

      }

      let arr = [this.tableData[index].chang, this.tableData[index].kuan, this.tableData[index].gao]
      arr.sort((e, b) => { return b - e });
      if (this.xzinfo.xzType.indexOf('1') != -1) {
        if (arr[0] > this.xzinfo.bcAstrict.one) {
          empty(this)
          return this.$message('最长边超过限制。')
        }
        if (arr[1] > this.xzinfo.bcAstrict.two) {
          empty(this)
          return this.$message('次边长超过限制。')

        }
        if (arr[2] > this.xzinfo.bcAstrict.three) {
          empty(this)
          return this.$message('最短长超过限制。')
        }
      }
      if (this.xzinfo.xzType.indexOf('2') != -1) {
        if ((parseFloat(arr[1]) + parseFloat(arr[2])) * 2 + parseFloat(arr[0]) > parseFloat(this.xzinfo.zcAstrict)) {
          empty(this)
          return this.$message('周长超过限制。')

        }
      }
      if (this.xzinfo.xzType.indexOf('3') != -1 && this.tableData[index].weight > this.xzinfo.zlAstrict) {
        this.$nextTick(() => {
          this.tableData[index].weight = 1
        })
        return this.$message('重量超过限制。')
      }

    },
    //   ---------添加箱----------
    addBox () {
      this.$confirm('添加新的一箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.tableData.push({
          no: parseInt(this.tableData.length, 10) + 1,
          chang: 1,
          kuan: 1,
          gao: 1,
          weight: 1,
          wpinfo: [{
            name: '',
            enname: '',
            num: ''
          }]
        })
        this.activeNames.push(parseInt(this.tableData.length, 10))
        this.$message({
          type: 'success',
          message: '添加成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //   ---------删除箱----------
    removeBox (index) {
      this.$confirm('删除整箱吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData.splice(index, 1)
        this.activeNames = [];
        for (const key in this.tableData) {
          this.tableData[key].no = parseInt(key, 10) + 1;
          this.activeNames.push(parseInt(key, 10) + 1)
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //   ----------添加物品----------
    addGoods (index) {
      this.tableData[index].wpinfo.push({
        cnname: '',
        enname: '',
        num: ''
      })
    },
    //   ----------删除物品----------
    removeGoods (index, index_1) {
      this.$confirm('此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData[index].wpinfo.splice(index_1, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style lang='scss'>
.packingList_module {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .packingList_title {
    width: 100%;
    font-size: 18px;
    margin: 50px 0 20px 0;
    display: flex;
    justify-content: space-between;
    padding: 0 10% 0 0;
    box-sizing: border-box;
    color: #333;
    span {
      font-weight: 700;
    }
  }
  .packingList_module_view {
    width: 70%;
    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .zxdinfo_title {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      .zxdinfo_view {
        height: 100%;
        // background-color: pink;
        display: flex;
        .zxdinfo_view_item {
          display: flex;
          align-items: center;
          margin-right: 20px;
          // border: 1px solid #999;
          border-radius: 10px;
          padding: 0 0 0 10px;
          .item_unit {
            font-size: 12px;
          }
          .el-input {
            margin: 0;
          }
          .el-input-number {
            width: 60px;
            input {
              height: 25px;
              background-color: #eee;
            }
          }
          .el-input__inner {
            // text-align: left;
          }
          .item_title {
            color: #666;
            font-weight: 700;
            font-size: 12px;
          }
        }
      }
    }

    .el-input-number {
      width: 90%;
      .el-input__inner {
        padding: 0;
      }
      .el-input-number__decrease,
      .el-input-number__increase {
        display: none !important;
      }
    }
    .el-collapse-item__header {
      font-size: 18px;
    }
    .addGoods {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
    .el-input {
      width: 70%;
      input {
        border: 0;
        text-align: center;
      }
    }
    td,
    th {
      padding: 5px 0;
    }
  }
  .expand {
    .cell {
      text-align: center;
    }
  }
  //   background-color: pink;
}
</style>